import { Text } from '@mantine/core';
import { Controlled_RichText } from '../../../../../react-commons/components/inputs/controlled/Controlled_RichText';
import { ContentSectionContentType } from '../../../resource/enumerations/ContentSectionContentType';
import { Controlled_Markdown } from '../../../../../react-commons/components/inputs/controlled/Controlled_Markdown';
import { ImageContentDisplay } from './ImageContentDisplay';
import ReactPlayer from 'react-player/lazy';
import { LazyVideoContentDisplay } from './LazyVideoContentDisplay';
import {
    useContentSectionContentActions,
} from '../../../resource/resources/artifacts/content/contentSectionContentResource';

export const ContentSectionContentDisplay= ({contentSectionContentId, showOnlyIfNotAvailable, showOnlyIfAvailable}: {
    contentSectionContentId: string;
    showOnlyIfNotAvailable?: boolean
    showOnlyIfAvailable?: boolean
}) => {
    const contentSectionContentActions = useContentSectionContentActions()

    const contentSectionContentQuery = contentSectionContentActions.useGetResource(contentSectionContentId)

    if (!contentSectionContentQuery.data?.id) {
        if (showOnlyIfAvailable) {
            return <div></div>
        }
        return <Text>No Section Content Available</Text>
    } else if (showOnlyIfNotAvailable) {
        return <div></div>
    } else if (contentSectionContentQuery.data.type === ContentSectionContentType.RICH_TEXT) {
        return (<Controlled_RichText readonly={true} value={contentSectionContentQuery.data?.text}/>);
    } else if (contentSectionContentQuery.data.type === ContentSectionContentType.MARKDOWN) {
        return (<Controlled_Markdown readonly={true} value={contentSectionContentQuery.data?.text}/>);
    } else if (contentSectionContentQuery.data.type === ContentSectionContentType.PLAIN_TEXT) {
        return <Text style={{whiteSpace: "pre-wrap"}}>{contentSectionContentQuery.data?.text}</Text>
    } else if (contentSectionContentQuery.data.type === ContentSectionContentType.IMAGE_ATTACHMENT) {
        return <ImageContentDisplay imageAttachmentObjectId={contentSectionContentQuery.data.image} versionedIn={contentSectionContentQuery.data.versionedIn} height={contentSectionContentQuery.data?.decorator?.height ?? 360}/>
    }else if (contentSectionContentQuery.data.type === ContentSectionContentType.VIDEO_ATTACHMENT) {
        return <LazyVideoContentDisplay videoAttachmentObjectId={contentSectionContentQuery.data.video} versionedIn={contentSectionContentQuery.data.versionedIn} height={contentSectionContentQuery.data?.decorator?.height ?? 360}/>
    } else if (contentSectionContentQuery.data.type === ContentSectionContentType.VIDEO_URL) {
        const url = contentSectionContentQuery.data.url
        if (url) {
            return <ReactPlayer width={"100%"} height={contentSectionContentQuery.data?.decorator?.height ?? 360} url={url} controls />
        }
        return <Text>No Video Url found</Text>
    }
    return <Text>No Section Content Available</Text>
};
